import { Autocomplete, Backdrop, FormControlLabel, IconButton, InputAdornment, Paper, Popover, Popper, Radio, RadioGroup, TextField, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useDebounce } from 'use-debounce';
import { resetPosts, setPostKeyword } from '../../../redux/actions';
import { setTrendingKeyword } from '../../../redux/actions/trending';
import { getSearchUsers, resetUsers, setSearchKeyword, setSearchType } from '../../../redux/actions/search';

import './style.scss';
import './style.darkmode.scss';

const DEBOUNCE_DELAY = 800;

const PostUserSearch = ({
    users,
    type,
    darkmode
}) => {
    const dispatch = useDispatch();
    const theme = useTheme();

    const [fullForm, setFullForm] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isCleared, setIsCleared] = useState(false);

    const toggleForm = (e) => {
        e.preventDefault();
        setFullForm(true);
    };

    const handleFocus = useCallback((e) => {
        setIsFocused(true);
    }, []);

    const handleBlur = useCallback((e) => {
        setIsFocused(false);
        setIsHovered(false);
    }, []);

    const handleHover = useCallback((e) => {
        setIsHovered(true);
    }, []);

    const handleLeave = useCallback((e) => {
        setIsHovered(false);
    }, []);

    useEffect(() => {
        if (fullForm) {
            document.getElementById('postUserSearch').focus();
        }
    }, [fullForm]);

    const handleClear = () => {
        setKeyword('');
        setIsCleared(true);
    };

    const handleKeywordChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleSearchByChange = e => {
        dispatch(setSearchType(e.target.value));
    };

    const handleClick = e => {
        const targetName = e.target.name;
        const targetId = e.target.id;

        if (!['searchInput', 'searchOption', 'search-group'].includes(targetName) && !['searchOptions'].includes(targetId)) {
            setFullForm(false);
        }
    };

    useEffect(() => {
        if (fullForm) {
            setFullForm(true);
            window.addEventListener('click', handleClick);
        } else {
            window.removeEventListener('click', handleClick);
            setFullForm(false);
        }

        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, [fullForm]);

    const handleSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }

        if (type === 'post') {
            // reset post
            dispatch(resetPosts());
            dispatch(setPostKeyword(keyword));
        } else {
            dispatch(setSearchKeyword(keyword));
            dispatch(getSearchUsers({
                perPage: 15,
                keyword: keyword,
                skip: users && users.length > 0 ? users.length : 0,
                trending: false
            }));
        }

        setIsCleared(false);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            dispatch(resetUsers());
            handleSubmit(event);
        }
    };

    useEffect(() => {
        if (isCleared) {
            handleSubmit();
        }
    }, [isCleared]);

    return <div className='post-user-form'>

        {
            fullForm
                ? <React.Fragment>
                    <TextField
                        id='postUserSearch'
                        variant='outlined'
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onMouseOver={handleHover}
                        onMouseLeave={handleLeave}
                        onChange={handleKeywordChange}
                        onKeyDown={handleKeyDown}
                        type="text"
                        size='small'
                        margin='dense'
                        label={`Search ${type}`}
                        InputProps={{
                            endAdornment: keyword.length > 0
                                ? <InputAdornment position="end">
                                    <span onClick={handleClear} style={{ backgroundColor: theme.palette.background.default }}>
                                        <i className='fal fa-times search-clear-icon'></i>
                                    </span>
                                </InputAdornment>
                                : null,
                            name: 'searchInput',
                            sx: {
                                backgroundColor: `${theme.palette.background.default} !important`
                            },
                            style: {
                                backgroundColor: `${theme.palette.background.default} !important`
                            }
                        }}
                        value={keyword}
                        fullWidth
                        sx={{
                            backgroundColor: theme.palette.background.default
                        }}
                    />
                    <div
                        id="searchOptions"
                        className={`
                        post-user-form__options
                        ${isFocused ? ' post-user-form__options-focused' : ''}
                        ${isHovered ? ' post-user-form__options-hovered' : ''}
                    `}

                        style={!darkmode
                            ? {
                                backgroundColor: theme.palette.background.default,
                            }
                            : {
                                backgroundColor: theme.palette.background.default,
                                borderRight: '1px solid rgba(255, 255, 255, 0.23)',
                                borderBottom: '1px solid rgba(255, 255, 255, 0.23)',
                                borderLeft: '1px solid rgba(255, 255, 255, 0.23)',
                            }
                        }
                    >
                        <RadioGroup
                            row
                            aria-labelledby="search-group"
                            name="search-group"
                        >
                            <FormControlLabel
                                value="post"
                                control={<Radio />}
                                label="Post"
                                checked={type === 'post'}
                                onChange={handleSearchByChange}
                                id="s"
                                name="searchOption"
                            />
                            <FormControlLabel
                                value="creator"
                                control={<Radio />}
                                label="Creator"
                                checked={type === 'creator'}
                                onChange={handleSearchByChange}
                                id="searchOption"
                                name="searchOption"
                            />
                        </RadioGroup>
                    </div>

                    {/*
                    <Popper
                        id='searchOptions'
                        open={showSuggestion}
                        anchorEl={anchorEl}
                        onClose={() => ({})}
                        placement='bottom-start'
                    >
                        <Paper
                            sx={{
                                padding: '4px 8px',
                            }}
                            className='search-options'
                        >
                            <RadioGroup
                                row
                                aria-labelledby="search-group"
                                name="search-group"
                            >
                                <FormControlLabel
                                    value="post"
                                    control={<Radio />}
                                    label="Post"
                                    checked={type === 'post'}
                                    onChange={handleSearchByChange}
                                    id="searchOption"
                                    name="searchOption"
                                />
                                <FormControlLabel
                                    value="creator"
                                    control={<Radio />}
                                    label="Creator"
                                    checked={type === 'creator'}
                                    onChange={handleSearchByChange}
                                    id="searchOption"
                                    name="searchOption"
                                />
                            </RadioGroup>
                        </Paper>
                    </Popper> */}
                </React.Fragment>

                : null
        }

        {
            !fullForm
                ? <IconButton
                    aria-label='Search'
                    onClick={toggleForm}
                >
                    <i className="fa-regular fa-magnifying-glass"></i>
                </IconButton>
                : null
        }

    </div >;
};

const mapStateToProps = state => ({
    users: state.search.users,
    type: state.search.type,
    darkmode: state.privaGlobal.darkmode,
});

export default connect(mapStateToProps)(PostUserSearch);